import { render, staticRenderFns } from "./ClientDetailForm.vue?vue&type=template&id=965776a2&"
import script from "./ClientDetailForm.vue?vue&type=script&lang=js&"
export * from "./ClientDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports